import React from 'react';
import PropTypes from 'prop-types';
import TextInput from '../../../core/form/TextInput';

const CheckoutLinkListFilter = (props) => (
  <TextInput
    label="Search links"
    placeholder="Start type to filter the links by customer"
    value={props.value}
    onChange={props.onChange}
  />
);

CheckoutLinkListFilter.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default CheckoutLinkListFilter;
